module.exports = __webpack_public_path__ + "img/auth-box-left.eee90f05.png";